export const LOCATION = {
  NY: 'New York',
  NC: 'North Carolina',
};

export const LOCATION_OPTION = {
  ALL: 'All',
  NY: 'New York',
  NC: 'North Carolina',
};

export const LOCATION_CUSTOMER_OPTION = {
  ALL: '',
  NC: 'NC',
  NY: 'NY',
  EMPTY: 'EMPTY',
};

export const LOCATION_FILTER = {
  ALL: '',
  NY: 'NY',
  NC: 'NC',
};

export const DEFAULT_LOCATION_FILTER_TITLE = 'Location';

export const LOCATION_FILTER_TITLE = {
  [LOCATION_CUSTOMER_OPTION.ALL]: 'Any Location',
  [LOCATION_CUSTOMER_OPTION.NY]: 'New York',
  [LOCATION_CUSTOMER_OPTION.NC]: 'North Carolina',
  [LOCATION_CUSTOMER_OPTION.EMPTY]: 'Empty Location',
};

export const LOCATION_ALL = 'All';

export const LOCATION_OPTION_ALL_VALUE = 'ALL';
